module.exports = __webpack_public_path__ + "812b0636e8554aad0f194d9f8c43911f.MP3";